import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

export default function FaqItem({
  question,
  answer,
  isOpen: initialOpen = false,
  className,
}) {
  const [isOpen, setIsOpen] = useState(initialOpen);

  // whenever question answer change  reset it to false
  useEffect(() => {
    setIsOpen(false);
  }, [question, answer]);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div
      className={`border border-darkMode-layer3 rounded-xl p-4 shadow-sm transition-all ease-in-out duration-300 bg-darkMode-layer2 ${className}`}
      role="button"
      onClick={toggleOpen}
      tabIndex={0}
      aria-expanded={isOpen}
    >
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium text-darkMode-text">{question}</h2>
        <FontAwesomeIcon
          size="sm"
          icon={isOpen ? faMinus : faPlus}
          className={`text-darkMode-subText/50 transition-all duration-500 ${
            isOpen ? "" : "rotate-90"
          }`}
        />
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "mt-3 max-h-screen" : "max-h-0"
        }`}
      >
        <p className="text-darkMode-subText">{isOpen && answer}</p>
      </div>
    </div>
  );
}
